import { Link } from "react-router-dom";
import { AnimatedSection } from "@/components/common/AnimatedSection";
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone } from "lucide-react";

export const Newsletter = () => {
  return (
    <section className="bg-primary py-12 lg:py-14" data-testid="cta-section">
      <div className="container-wide px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <div className="text-center max-w-xl mx-auto">
            <p className="text-accent text-xs font-semibold tracking-widest uppercase mb-3">Ready to Travel?</p>
            <h2 className="heading-md text-white mb-3">
              Start Planning Your Dream Trip Today
            </h2>
            <p className="text-sm text-white/70 mb-6 leading-relaxed">
              Get a personalized quote — free, fast, and tailored to your travel vision. Our experts respond within 24 hours.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Link to="/contact">
                <Button
                  size="default"
                  className="bg-white text-primary hover:bg-white/90 gap-2 w-full sm:w-auto font-semibold px-6"
                  data-testid="cta-quote-btn"
                >
                  Get Your Free Quote <ArrowRight className="h-4 w-4" />
                </Button>
              </Link>
              <Button
                variant="navyOutline"
                size="default"
                className="w-full sm:w-auto gap-2 px-6"
                asChild
                data-testid="cta-call-btn"
              >
                <a href="tel:+19726661122">
                  <Phone className="h-4 w-4" />
                  Call Us Now
                </a>
              </Button>
            </div>
            <p className="text-xs text-white/40 mt-4">No commitment required. Free quotes, always.</p>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};
